import RightPanelTab from '@/global/components/right-panel-tab'
import { Sensor } from '@/global/interface/device/sensor'
import { MonitorObject } from '@/global/interface/monitor-object/monitor-object'
import { MonitorParameter } from '@/global/interface/monitor-object/monitor-parameter'
import { useEffect, useState } from 'react'
import MonitorParameterWarningSetting from '../monitor-object/info/param'

interface IProps {
    sensor: Sensor
    monitorObjects: MonitorObject[]
}

export default function MonitorSettingPanel(props: IProps) {
    const [activeTab, setActiveTab] = useState<'params' | 'manager' | 'setting'>("params") // 当前激活栏

    const [monitorParameters, setMonitorParameters] = useState<MonitorParameter[]>([]);

    useEffect(() => {
        if (props.monitorObjects == null) return;
        let params: MonitorParameter[] = [];
        props.monitorObjects.forEach(item => {
            item?.rootMonitorParameters.forEach(param => {
                if (param.symbol == "deform" || param.symbol == "invasion_size") {
                    param.monitorObjectName = item.name;
                    params.push(param);
                }
            });
        })
        setMonitorParameters(params)
    }, [props.monitorObjects])

    return (
        <div className='monitor-setting-panel'>
            <div className="tab-area">
                <RightPanelTab
                    dataList={[
                        { label: "物理参数", value: "params" },
                        { label: "设置", value: "setting" },
                    ]}
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                />
            </div>
            <div className="third-main">
                {activeTab == "params" && (
                    <div className="params-main">
                        <div className="item">
                            <div className="item-name">代号：</div>
                            <div className="item-value">{props.sensor?.code || ''}</div>
                        </div>
                        <div className="item">
                            <div className="item-name">型号：</div>
                            <div className="item-value">{props.sensor?.marking || ''}</div>
                        </div>
                        <div className="item">
                            <div className="item-name">量程：</div>
                            <div className="item-value">{props.sensor?.range || ''}</div>
                        </div>
                        <div className="item">
                            <div className="item-name">精度：</div>
                            <div className="item-value">{props.sensor?.precision || ''}</div>
                        </div>
                    </div>
                )}
                {activeTab == "setting" && (
                    <div className="setting-main">
                        <div className="param">
                            <div className="name header"></div>
                            <div className="cell header">二级预警值</div>
                            <div className="cell sec header">三级预警值</div>
                            <div className="cell third header">四级预警值</div>
                        </div>
                        {monitorParameters?.map(param => (
                            <MonitorParameterWarningSetting
                                param={param}
                                onUpdateParam={(id: number, data) => {
                                    let newParam = { ...param, ...data };
                                    let params = [...monitorParameters];
                                    let idx = monitorParameters.findIndex(item => item.id == id);
                                    if (idx < 0) return;
                                    params.splice(idx, 1, newParam);
                                    setMonitorParameters(params);
                                }}
                            />
                        ))}
                    </div>
                )}

            </div>
        </div>
    )
}
